import AppContainer from './container';
import CreateHistory from 'history/createBrowserHistory';
// import DevTools from './components/devTools';
import React, { Component } from 'react';
import Reducer from './reducers';
import ThunkMiddleware from 'redux-thunk';

import { applyMiddleware, compose, createStore } from 'redux';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import { createLogger } from 'redux-logger';
import { loadState, saveState } from './lib/localStorage';
import { Provider } from 'react-redux';

const history = CreateHistory();
const loggerMiddleware = createLogger({ predicate: (getState, action) => process.env.NODE_ENV === 'development' });
const persistanceState = loadState();

// function configureStore(initialState) {
//     const enhancer = compose(
//         applyMiddleware(
//             ThunkMiddleware,
//             loggerMiddleware,
//             routerMiddleware(history)
//         ),
//         DevTools.instrument()
//     );
//     return createStore(Reducer, initialState, enhancer)
// }


function configureStore(initialState) {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const enhancer = composeEnhancers(
        applyMiddleware(
            ThunkMiddleware,
            loggerMiddleware,
            routerMiddleware(history)
        )
    );
    return createStore(Reducer, initialState, enhancer)
}


export const store = configureStore(persistanceState);
store.subscribe(() => {
    saveState({
        loggedinUser : store.getState().loggedinUser,
        isLoggedin :  store.getState().isLoggedin
    });
})

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <AppContainer />
                </ConnectedRouter>
            </Provider>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js